import React, { Component } from "react";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import CircularProgress from "@material-ui/core/CircularProgress";

import { updateUserRole } from "../api/user";

const Transition = (props) => {
  return <Slide direction="up" {...props} />;
};

class EditRoleDialog extends Component {
  static defaultProps = {
    onClose: () => null,
    defaultRole: "mi-treasure.sale",
  };

  state = {
    loading: false,
    role: "",
  };

  componentDidMount() {}

  handleClose = (e) => {
    this.props.onClose(true);
  };

  handleCancel = (e) => {
    this.handleClose(e);
  };

  save = (e) => {
    const { uid } = this.props.user;
    const { role } = this.state;
    this.handleClose();
    this.setState({
      loading: true,
    });
    updateUserRole(uid, role)
      .then((user) => {
        console.log("updateUserRole", user);
        this.setState({
          open: false,
        });
        this.props.onUpdate(user);
        if (this.props.onSuccess) this.props.onSuccess(user);
      })
      .catch((error) => {
        if (this.props.onError) this.props.onError(error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleChangeRole = (e) => {
    this.setState({
      role: e.target.value,
    });
  };

  render() {
    const { loading, role } = this.state;
    return (
      <Dialog
        open={this.props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={this.handleClose}
        aria-labelledby="edit-profile"
        aria-describedby="edit-profile-description"
      >
        <DialogTitle id="edit-profile">Edit Role</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: 500,
              maxWidth: "100%",
            }}
          >
            <FormControl
              component="fieldset"
              required
              style={{ marginBottom: 12 }}
            >
              <FormLabel component="legend">Role</FormLabel>
              <RadioGroup
                aria-label="role"
                name="role"
                value={role}
                onChange={this.handleChangeRole}
              >
                <FormControlLabel
                  value="mi-treasure.admin"
                  control={<Radio />}
                  label="Admin"
                />
                <FormControlLabel
                  value="mi-treasure.sale"
                  control={<Radio />}
                  label="Editor"
                />
                <FormControlLabel
                  value="mi-treasure.alliance"
                  control={<Radio />}
                  label="Moderator"
                />
                <FormControlLabel
                  value="mi-treasure.audience"
                  control={<Radio />}
                  label="Audience"
                />
                <FormControlLabel
                  value="mi-treasure.general-member"
                  control={<Radio />}
                  label="General Member"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={this.save} color="primary" disabled={loading}>
            {!loading ? "Save" : <CircularProgress size={24} />}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default EditRoleDialog;



// WEBPACK FOOTER //
// ./src/admin/components/EditRoleDialog.js